import { HospitalReviewSortEnum } from "@/entities/hospital/types/type"
import { create } from "zustand"

interface FeaturesHospitalStore {
  selectedReviewSort: HospitalReviewSortEnum
  setSelectedReviewSort: (selectedReviewSort: HospitalReviewSortEnum) => void
  isOpenReviewFilterModal: boolean
  setIsOpenReviewFilterModal: (isOpenReviewFilterModal: boolean) => void
  selectedReviewFilterTab: "treatmentCase" | "detail"
  setSelectedReviewFilterTab: (selectedReviewFilterTab: "treatmentCase" | "detail") => void
  selectedSubjectFilter: string
  setSelectedSubjectFilter: (selectedSubjectFilter: string) => void
  selectedDetailFilter: {
    major: string
    minor: string
  }
  setSelectedDetailFilter: (selectedDetailFilter: { major: string; minor: string }) => void
  resetReviewFilter: () => void
}

export const useFeaturesHospitalStore = create<FeaturesHospitalStore>((set) => ({
  selectedReviewSort: HospitalReviewSortEnum.LATEST,
  setSelectedReviewSort: (selectedReviewSort: HospitalReviewSortEnum) => set({ selectedReviewSort }),
  isOpenReviewFilterModal: false,
  setIsOpenReviewFilterModal: (isOpenReviewFilterModal: boolean) => set({ isOpenReviewFilterModal }),
  selectedReviewFilterTab: "treatmentCase",
  setSelectedReviewFilterTab: (selectedReviewFilterTab: "treatmentCase" | "detail") =>
    set({ selectedReviewFilterTab }),
  selectedSubjectFilter: "",
  setSelectedSubjectFilter: (selectedSubjectFilter: string) => set({ selectedSubjectFilter }),
  selectedDetailFilter: { major: "", minor: "" },
  setSelectedDetailFilter: (selectedDetailFilter) => set({ selectedDetailFilter }),
  resetReviewFilter: () =>
    set({
      selectedDetailFilter: { major: "", minor: "" },
      selectedSubjectFilter: "",
    }),
}))

interface FeaturesHospitalDataStore {
  selectedTreatmentCaseFilterData: { id: number; treatment: string } | null
  setSelectedTreatmentCaseFilterData: (
    selectedTreatmentCaseFilterData: { id: number; treatment: string } | null
  ) => void
  selectedDetailFilterData: {
    major: string | null
    minor: string | null
  }
  setSelectedDetailFilterData: (selectedDetailFilterData: { major: string | null; minor: string | null }) => void
  resetReviewFilterData: () => void
}

export const useFeaturesHospitalDataStore = create<FeaturesHospitalDataStore>((set) => ({
  selectedTreatmentCaseFilterData: null,
  setSelectedTreatmentCaseFilterData: (
    selectedTreatmentCaseFilterData: { id: number; treatment: string } | null
  ) => set({ selectedTreatmentCaseFilterData }),
  selectedDetailFilterData: { major: null, minor: null },
  setSelectedDetailFilterData: (selectedDetailFilterData) => set({ selectedDetailFilterData }),
  resetReviewFilterData: () =>
    set({
      selectedDetailFilterData: { major: null, minor: null },
      selectedTreatmentCaseFilterData: null,
    }),
}))
